/**
 * MCP Bus core types — shared between Studio and Runtime buses.
 */

export const STUDIO_NS = 'cogo.studio.' as const
export const RUNTIME_NS = 'cogo.runtime.' as const

export interface McpCommand {
  tool: string // e.g. 'cogo.studio.addElement'
  params: Record<string, unknown>
}

export type StudioCapabilityApprovalVerifier = (cmd: McpCommand) => void

export interface McpResult {
  success: boolean
  data?: unknown
  error?: string
}

export type Middleware = (
  cmd: McpCommand,
  next: () => Promise<McpResult>,
) => Promise<McpResult>
